import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Spinner } from "react-bootstrap";
import { slugify } from "transliteration";
import {
  currentLocation,
  inputWrapper,
  searchResults,
  sectionContainer,
  sectionTitle,
  sectionTitleText,
  wrapper,
} from "./SearchAutoComplete.module.scss";

export const SectionContainer: React.FC<any> = (props) => {
  return <div className={sectionContainer}>{props.children}</div>;
};
export const CurrentLocation: React.FC<any> = (props) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") {
      props.onClick();
    }
  };
  return (
    <div
      className={currentLocation}
      tabIndex={0}
      role="button"
      onKeyDown={handleKeyDown}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};
export const SearchResults: React.FC<any> = (props) => {
  return <div className={searchResults}>{props.children}</div>;
};
export const InputWrapper: React.FC<any> = (props) => {
  return <div className={inputWrapper}>{props.children}</div>;
};
export const SectionTitle: React.FC<any> = (props) => {
  return (
    <div className={`${sectionTitle} ${props.className}`}>{props.children}</div>
  );
};
export const SectionTitleText: React.FC<any> = (props) => {
  return (
    <div id={props.id} className={sectionTitleText}>
      {props.children}
    </div>
  );
};
export const Wrapper: React.FC<any> = (props) => {
  return <div className={wrapper}>{props.children}</div>;
};
/* to render suggestion when input is null  */
export const shouldRenderSuggestions = (): boolean => {
  return true;
};
export const renderInputComponent = (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  props: any,
  isLoading: boolean,
  errors: string
): JSX.Element => {
  return (
    <InputWrapper>
      <span className={`searchIcon ${errors && "d-none"}`}>
        {isLoading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </>
        )}
      </span>
      <label>
        <input tabIndex={0} {...props} aria-label="Autosuggest" />
      </label>
      <span className={`searchIcon ${isLoading && "d-none"}`}>
        <FontAwesomeIcon icon={faMapMarkerAlt} />
      </span>
      {errors ? <div className="requiredError">{errors}</div> : null}
    </InputWrapper>
  );
};
export const renderSectionTitle: React.FC<any> = (section) => {
  return (
    section.type && (
      <SectionTitle className={`${section.class}`}>
        {renderIcons(section.class)}
        <SectionTitleText
          id={slugify(section.type)}
          className={`section-title-icon`}
        >
          {section.type}
        </SectionTitleText>
      </SectionTitle>
    )
  );
};
export const setOverlayTop = (): void => {
  const datesDiv = document.getElementById("global-search-autocomplete");
  if (
    datesDiv &&
    window.innerHeight - datesDiv.getBoundingClientRect().y < 350
  ) {
    if (document.getElementById("react-autowhatever-1")) {
      const doc = document.getElementById("react-autowhatever-1");
      doc ? (doc.style.bottom = "50px") : null;
    }
  } else {
    if (document.getElementById("react-autowhatever-1")) {
      const doc = document.getElementById("react-autowhatever-1");
      doc ? (doc.style.bottom = "auto") : null;
    }
  }
};

function renderIcons(icon: string) {
  if (icon === "points") {
    return (
      <StaticImage
        src="../../../../svg/icon-points-of-interest.svg"
        alt="points Icon"
        formats={["png", "webp"]}
      ></StaticImage>
    );
  }
  if (icon === "cities") {
    return (
      <StaticImage
        src="../../../../svg/icon-regions.svg"
        alt="cities Icon"
        formats={["png", "webp"]}
      ></StaticImage>
    );
  }
  if (icon === "airports") {
    return (
      <StaticImage
        src="../../../../svg/icon-airports.svg"
        alt="airports Icon"
        formats={["png", "webp"]}
      ></StaticImage>
    );
  }
  if (icon === "hotels") {
    return (
      <StaticImage
        src="../../../../svg/icon-hotels.svg"
        alt="hotels Icon"
        formats={["png", "webp"]}
      ></StaticImage>
    );
  }
  if (icon === "cruises") {
    return (
      <StaticImage
        src="../../../../svg/icon-cruise.svg"
        alt="hotels Icon"
        formats={["png", "webp"]}
      ></StaticImage>
    );
  }
  if (icon === "recent") {
    return (
      <StaticImage
        src="../../../../svg/Vector.svg"
        alt="Vector Icon"
        formats={["png", "webp"]}
      ></StaticImage>
    );
  }
}
